import React from "react";

const SubscriptionContext = React.createContext({
    numberOfTrialDays: 7,
    setNumberOfTrialDays: () => { },
    isTrialStarted: false,
    setIsTrialStarted: () => { },
    isTrialExpired: false,
    setIsTrialExpired: () => { },
    isPaid: false,
    setIsPaid: () => { },
    isExpired: false,
    setIsExpired: () => { },
    formattedExpiryDate: null,
    setFormattedExpiryDate: () => { },
    currentPlan: null,
    setCurrentPlan: () => { },
    formattedTrialExpiryDate: null,
    setFormattedTrialExpiryDate: () => { }
});

export default SubscriptionContext;